import areaList from "@/libs/areaList";
import { isPhone, isTel } from "@/libs/common";
import { isUleUser, savaAndUpdate } from "@/libs/api";
export default {
	name: "pointAdd",
	data() {
		return {
			areaList,
			popupShow: false,
			currentAdcode: "110101",
			channelBusO2oSiteDto: {
				id: "",
				siteName: "",
				siteDesc: "",
				orgPhone: "",
				provinceId: "",
				provinceName: "",
				cityId: "",
				cityName: "",
				areaId: "",
				areaName: "",
				address: "",
				currentAddress: "",
				// 核销员列表
				channelBusO2oSmRelationDtoList: [
					{
						id: "",
						siteId: "",
						managerId: "",
						managerName: "",
						mobile: "",
						mobileEmpty: false,
						mobileChecked: false,
						mobileHas: false,
					},
				],
			},
		};
	},
	mounted() {
		// 获取当前定位
		if (this.$browser().ylxdsq) {
			this.getAppPos();
		} else {
			if (this.$browser().miniprogram) {
				if (this.getStorage("home", "home.AD_CODE_MIN") !== 0) {
					this.currentAdcode = this.getStorage("home", "home.AD_CODE_MIN");
				}
			} else {
				if (this.getStorage("home", "home.AD_CODE") !== 0) {
					this.currentAdcode = this.getStorage("home", "home.AD_CODE");
				}
			}
		}
	},
	mounted() {},
	methods: {
		// 省市区选择确认
		onAddrConfirm(e) {
			this.channelBusO2oSiteDto.provinceId = e[0].code;
			this.channelBusO2oSiteDto.cityId = e[1].code;
			this.channelBusO2oSiteDto.areaId = e[2].code;
			this.channelBusO2oSiteDto.provinceName = e[0].name;
			this.channelBusO2oSiteDto.cityName = e[1].name;
			this.channelBusO2oSiteDto.areaName = e[2].name;
			this.channelBusO2oSiteDto.currentAddress = `${e[0].name}/${e[1].name}/${e[2].name}`;
			// if (e[0].name === e[1].name) {
			// 	this.currentAddress = `${e[0].name}/${e[2].name}`;
			// } else {
			// 	this.currentAddress = `${e[0].name}/${e[1].name}/${e[2].name}`;
			// }
			console.log(this.channelBusO2oSiteDto);
			this.popupShow = false;
		},
		// 添加核销人
		addWriter() {
			this.channelBusO2oSiteDto.channelBusO2oSmRelationDtoList.push({
				id: "",
				siteId: "",
				managerId: "",
				managerName: "",
				mobile: "",
				mobileEmpty: false,
				mobileChecked: false,
				mobileHas: false,
			});
			setTimeout(() => {
				let ele = document.getElementsByTagName("body")[0].scrollHeight;
				window.scrollTo({
					top: ele,
					behavior: "smooth",
				});
			}, 100);
		},
		// 删除核销人
		deleteWriter(index) {
			this.$dialog
				.confirm({
					title: "提示",
					message: "确认是否要删除该核销员信息?",
				})
				.then(() => {
					this.channelBusO2oSiteDto.channelBusO2oSmRelationDtoList.splice(index, 1);
				})
				.catch(() => {});
		},
		// 判断联系方式是否正确
		checkContact(item, index) {
			// 验证手机号是否存在
			if (item.mobile.length === 11) {
				if (isPhone(item.mobile)) {
					item.mobileChecked = true;
					this.$toast.loading({
						duration: 0,
						mask: true,
						message: "验证中...",
					});
					isUleUser({ mobile: item.mobile }, "jsonCallback").then((res) => {
						if (res.data === 0) {
							item.mobileHas = false;
							return this.$toast(`核销人${index + 1}联系方式不是邮乐用户，请重新输入`);
						} else {
							item.mobileHas = true;
							this.$toast.success(`验证成功`);
						}
					});
				} else {
					item.mobileChecked = false;
					return this.$toast(`核销人${index + 1}联系方式不正确`);
				}
			}
		},
		checkMobile(item, index) {
			// 验证手机号为空;
			if (item.mobile === "") {
				item.mobileEmpty = false;
				return this.$toast(`核销人${index + 1}联系方式不能为空`);
			} else {
				item.mobileEmpty = true;
				if (!isPhone(item.mobile)) {
					item.mobileChecked = false;
					return this.$toast(`核销人${index + 1}联系方式不正确`);
				}
			}
		},
		// 保存
		saveWriter() {
			this.$toast.loading({
				duration: 0,
				mask: true,
				message: "请稍后...",
			});
			if (this.channelBusO2oSiteDto.siteName === "") {
				return this.$toast("自提点名称不能为空");
			}
			if (this.channelBusO2oSiteDto.currentAddress === "") {
				return this.$toast("所在省市不能为空");
			}
			if (this.channelBusO2oSiteDto.address === "") {
				return this.$toast("详细地址不能为空");
			}
			if (this.channelBusO2oSiteDto.orgPhone === "") {
				return this.$toast("联系方式不能为空");
			} else {
				if (!isPhone(this.channelBusO2oSiteDto.orgPhone) && !isTel(this.channelBusO2oSiteDto.orgPhone)) {
					return this.$toast(`自提点联系方式不正确`);
				}
			}
			// 验证核销人
			for (let i = 0; i < this.channelBusO2oSiteDto.channelBusO2oSmRelationDtoList.length; i++) {
				if (this.channelBusO2oSiteDto.channelBusO2oSmRelationDtoList[i].managerName === "") {
					return this.$toast(`核销人${i + 1}姓名不能为空`);
				}
				if (!this.channelBusO2oSiteDto.channelBusO2oSmRelationDtoList[i].mobileEmpty) {
					return this.$toast(`核销人${i + 1}联系方式不能为空`);
				}
				if (!this.channelBusO2oSiteDto.channelBusO2oSmRelationDtoList[i].mobileChecked) {
					return this.$toast(`核销人${i + 1}联系方式不正确`);
				}
				if (!this.channelBusO2oSiteDto.channelBusO2oSmRelationDtoList[i].mobileHas) {
					return this.$toast(`核销人${i + 1}联系方式不是邮乐用户，请重新输入`);
				}
			}
			setTimeout(() => {
				console.log(this.isRepeatMobile(this.channelBusO2oSiteDto.channelBusO2oSmRelationDtoList));
				if (this.isRepeatMobile(this.channelBusO2oSiteDto.channelBusO2oSmRelationDtoList)) {
					return this.$toast("不可提交多个相同的核销人手机号码");
				} else {
					console.log("提交数据");
					let submitData = JSON.stringify(this.channelBusO2oSiteDto);
					savaAndUpdate({ data: submitData, clientCallType: "h5" })
						.then((res) => {
							if (res.code === "0000" || res.returnCode === "0000") {
								this.$toast("添加自提点成功");
								setTimeout(() => {
									this.toNext(`/pickup/pointList`);
								}, 1000);
							} else if (res.code === "0010" || res.returnCode === "0010") {
								this.$toast(res.msg);
								setTimeout(() => {
									this.toNext(`/pickup/pointList`);
								}, 1000);
							} else if (res.code === "9999" || res.returnCode === "9999") {
								this.$toast("保存失败，请稍后再试！");
							} else {
								this.$toast(res.msg);
							}
						})
						.catch((error) => {
							console.log(error);
							this.$toast("保存失败，请稍后再试！");
						});
				}
			}, 1000);
		},
		// 获取App定位
		getAppPos() {
			window.dsBridge.register("getCurrentCityCode", (e) => {
				e = JSON.parse(e);
				// m.latitude = e.latitude;
				// m.longitude = e.longitude;
				// m.latng = e.latitude + "," + e.longitude;
				this.currentAdcode = e.cityCode;
				// alert(this.currentAdcode);
			});
			window.dsBridge.call("getCurrentCityCode", { ios_action: "getCurrentCityCode", android_action: "getCurrentCityCode", minversion: "207", maxversion: "999" });
		},
		// 手机号是否重复
		isRepeatMobile(arr) {
			for (let i = 0; i < arr.length - 1; i++) {
				for (let j = i + 1; j < arr.length; j++) {
					if (arr[i].mobile === arr[j].mobile) {
						return true;
					}
				}
			}
		},
	},
};
